module.exports = __webpack_public_path__ + "img/games-15.cd23bb65.webp";